module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-b-cropped.2450cbcf.jpg";